import React from 'react';
import './styles.css';
import UofTLogo from './img/U-of-T-logo.svg';
import { Button, Row, Col } from 'react-bootstrap';
import { url } from '../../constants/routes';

const FooterBar = () => (
  <footer role="footer">
    <div className="container">
      <Col xs={10} xsOffset={1} smOffset={0} sm={12} className="content">
        <Col xs={12} sm={6} className="logo">
          <a
            aria-label="Link to the University of Toronto website."
            href="https://www.utoronto.ca/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              width="162"
              height="60"
              src={UofTLogo}
              className="client-logo"
              alt="University of Toronto Logo"
            />
          </a>
        </Col>
        <Col xs={12} sm={6} className="copyright">
          <p>
            Copyright &copy; 2018-2023. University of Toronto<br />
            Questions? <a href="mailto:health.promotion@utoronto.ca">health.promotion@utoronto.ca</a><br />
            <a href={url.SITEMAP}>Sitemap</a>
          </p>
        </Col>
      </Col>
    </div>
  </footer>
);

const Footer = FooterBar;

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.jsx